import {
  AiOutlineTeam,
  AiOutlineHome,
  AiOutlineTable,
  AiOutlineGlobal,
  AiOutlineFundProjectionScreen,
  AiOutlineRise,
  AiOutlineProject,
  AiOutlineQuestionCircle,
  AiOutlineDotChart,
} from "react-icons/ai";
import { IoIosSettings } from "react-icons/io";
import { GiTriangleTarget } from "react-icons/gi";
import { MdOutlineLocalHospital } from "react-icons/md";
import { APP_ROUTES, APP_ROUTES_LABEL } from "./appConstants";

// Shared navigation configuration used by Sidebar, Home, and Output pages
export const NavigationMenu = [
  {
    name: APP_ROUTES_LABEL.patient_opportunity_mapping_and_strategy,
    id: APP_ROUTES.patient_opportunity_mapping_and_strategy,
    route: `/${APP_ROUTES.outputs}/${APP_ROUTES.patient_opportunity_mapping_and_strategy}`,
    icon: AiOutlineGlobal,
    color: "#6366f1",
    category: "Strategy",
    description: "Prioritize key areas of unmet need for Medical intervention",
  },
  {
    name: APP_ROUTES_LABEL.priority_engagement_opportunity_page,
    id: APP_ROUTES.priority_engagement_opportunity_page,
    route: `/${APP_ROUTES.outputs}/${APP_ROUTES.priority_engagement_opportunity_page}`,
    icon: AiOutlineDotChart,
    color: "#8b5cf6",
    category: "Strategy",
    description: "Explore unmet need by HCP, hospital, and payer to identify priority targets",
  },
  {
    name: APP_ROUTES_LABEL.geographic_unmet_need,
    id: APP_ROUTES.geographic_unmet_need,
    route: `/${APP_ROUTES.outputs}/${APP_ROUTES.geographic_unmet_need}`,
    icon: AiOutlineGlobal,
    color: "#ef4444",
    category: "Strategy",
    description: "Explore geographic patterns of unmet need across regions",
    alwaysVisible: true,
  },
  {
    name: APP_ROUTES_LABEL.eligible_patient_locator,
    id: APP_ROUTES.eligible_patient_locator,
    route: `/${APP_ROUTES.outputs}/${APP_ROUTES.eligible_patient_locator}`,
    icon: AiOutlineTable,
    color: "#ef4444",
    category: "Profiles",
    description: "Clinical profiles for top HCPs by priority unmet needs",
  },
  {
    name: APP_ROUTES_LABEL.institutional_variation,
    id: APP_ROUTES.institutional_variation,
    route: `/${APP_ROUTES.outputs}/${APP_ROUTES.institutional_variation}`,
    icon: MdOutlineLocalHospital,
    color: "#f97316",
    category: "Profiles",
    description: "Clinical profiles for hospitals, clinics, IDNs, and systems",
  },
  {
    name: APP_ROUTES_LABEL.payer_variation,
    id: APP_ROUTES.payer_variation,
    route: `/${APP_ROUTES.outputs}/${APP_ROUTES.payer_variation}`,
    icon: AiOutlineProject,
    color: "#eab308",
    category: "Profiles",
    description: "Clinical profiles for plans and payers by priority unmet needs",
  },
  {
    name: APP_ROUTES_LABEL.target_lists,
    id: APP_ROUTES.target_lists,
    route: `/${APP_ROUTES.outputs}/${APP_ROUTES.target_lists}`,
    icon: GiTriangleTarget,
    color: "#3b82f6",
    category: "Tracking",
    description: "Your selected HCPs, hospitals / systems, and plans",
  },
  {
    name: APP_ROUTES_LABEL.impact_tracking,
    id: APP_ROUTES.impact_tracking,
    route: `/${APP_ROUTES.outputs}/${APP_ROUTES.impact_tracking}`,
    icon: AiOutlineFundProjectionScreen,
    color: "#0ea5e9",
    category: "Tracking",
    description: "Measure changes in patient care and impact of initiatives",
  },
  {
    name: APP_ROUTES_LABEL.patient_journey,
    id: APP_ROUTES.patient_journey,
    route: `/${APP_ROUTES.outputs}/${APP_ROUTES.patient_journey}`,
    icon: AiOutlineRise,
    color: "#10b981",
    category: "Insights",
    description: "Gain a deeper understanding of asthma care patterns",
  },
  {
    name: APP_ROUTES_LABEL.help,
    id: APP_ROUTES.help,
    route: `/${APP_ROUTES.help}`,
    icon: AiOutlineQuestionCircle,
    color: "#6b7280",
    category: "Support",
    description: "Learn about the app or contact support",
  },
  {
    name: APP_ROUTES_LABEL.settings,
    id: APP_ROUTES.settings,
    route: `/${APP_ROUTES.outputs}/${APP_ROUTES.settings}`,
    icon: IoIosSettings,
    color: "#6b7280",
    category: "Support",
    description: "Adjust Settings for Medical AI Suite",
  },
];

// Sidebar menu sections configuration
export const sidebarMenuSections = [
  {
    id: "dashboard",
    items: [
      {
        name: APP_ROUTES_LABEL.users,
        id: APP_ROUTES.users,
        route: "/dashboard",
        icon: AiOutlineTeam,
        adminOnly: true,
      },
      {
        name: APP_ROUTES_LABEL.home,
        id: "home",
        route: "/dashboard",
        icon: AiOutlineHome,
      },
    ],
  },
  {
    id: "strategy",
    label: "Strategy",
    items: NavigationMenu.filter((item) => item.category === "Strategy"),
  },
  {
    id: "profiles",
    label: "Care Profiles",
    items: NavigationMenu.filter((item) => item.category === "Profiles"),
  },
  {
    id: "tracking",
    label: "Tracking",
    items: NavigationMenu.filter((item) => item.category === "Tracking"),
  },
  {
    id: "insights",
    label: "Insights",
    items: NavigationMenu.filter((item) => item.category === "Insights"),
  },
  {
    id: "support",
    label: "Support",
    items: [
      ...NavigationMenu.filter((item) => item.category === "Support"),
      {
        name: APP_ROUTES_LABEL.testing,
        id: APP_ROUTES.testing,
        route: `/${APP_ROUTES.outputs}/${APP_ROUTES.testing}`,
        icon: AiOutlineQuestionCircle,
      },
    ],
  },
];

// Get navigation item by ID
export const getNavigationItemById = (id) => {
  return NavigationMenu.find((item) => item.id === id);
};

// Get label data by ID (for Output page)
export const labelsPageData = Object.fromEntries(
  NavigationMenu.map((item) => [item.id, item])
);
